import { useTranslation } from 'react-i18next';

interface TypeFormData {
  name: string;
  description: string;
  color: string;
}

interface TypeFormModalProps {
  show: boolean;
  editing: boolean;
  formData: TypeFormData;
  submitting: boolean;
  onClose: () => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  onFieldChange: (field: keyof TypeFormData, value: string) => void;
  onGenerateColor: () => void;
}

const TypeFormModal = ({
  show,
  editing,
  formData,
  submitting,
  onClose,
  onSubmit,
  onFieldChange,
  onGenerateColor,
}: TypeFormModalProps) => {
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  return (
    <div className="modal modal-blur show" style={{ display: 'block' }} tabIndex={-1} role="dialog">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <form onSubmit={onSubmit} className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{editing ? t('warehouses.types.edit') : t('warehouses.types.add')}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label required">{t('warehouses.types.name')}</label>
              <input
                type="text"
                className="form-control"
                name="name"
                value={formData.name}
                onChange={(event) => onFieldChange('name', event.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">{t('warehouses.types.description')}</label>
              <textarea
                className="form-control"
                name="description"
                value={formData.description}
                onChange={(event) => onFieldChange('description', event.target.value)}
                rows={3}
              ></textarea>
            </div>
            <div className="mb-3">
              <label className="form-label">{t('warehouses.categories.color')}</label>
              <div className="input-group">
                <input
                  type="color"
                  className="form-control form-control-color"
                  name="color"
                  value={formData.color}
                  onChange={(event) => onFieldChange('color', event.target.value)}
                  title={t('common.pickColor')}
                  style={{ maxWidth: 50 }}
                />
                <input
                  type="text"
                  className="form-control font-monospace"
                  name="color"
                  value={formData.color}
                  onChange={(event) => onFieldChange('color', event.target.value)}
                  maxLength={7}
                  style={{ maxWidth: 100 }}
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={onGenerateColor}
                  title={t('common.generateColor') || 'Generate random color'}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>
                </button>
                <span
                  className="input-group-text"
                  style={{ backgroundColor: formData.color, width: 36, border: '1px solid var(--tblr-border-color)' }}
                />
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-link link-secondary" onClick={onClose} disabled={submitting}>
              {t('common.cancel')}
            </button>
            <button type="submit" className="btn btn-primary ms-auto" disabled={submitting}>
              {editing ? t('common.save') : t('common.create')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TypeFormModal;
